import * as React from "react";
import { useContext } from 'react';
import { AuthContext } from '../contexts';
var GoBack = function (_a) {
    var children = _a.children;
    var _b = useContext(AuthContext), registrationStep = _b.registrationStep, setRegistrationStep = _b.setRegistrationStep;
    return (React.createElement("button", { className: "unset-styles go-back", onClick: function () { return setRegistrationStep(registrationStep - 1); } }, children));
};
export { GoBack };
